import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.REACT_APP_AES_SECRET || 'fallback-secret-key-for-dev';

const ENCRYPTION_PREFIX = 'OOMERO_ENC:';

/**
 * Encrypts data using AES-256
 * @param {Object|Array|string} data - The data to encrypt
 * @returns {string} - The encrypted string with prefix
 */
export const encryptData = (data) => {
  if (data === null || data === undefined || data === '') return data;
  try {
    // Check if already encrypted with our prefix
    if (typeof data === 'string' && data.startsWith(ENCRYPTION_PREFIX)) {
        return data; 
    }

    const jsonString = typeof data === 'string' ? data : JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
    return `${ENCRYPTION_PREFIX}${encrypted}`;
  } catch (error) {
    console.error('Encryption Failed:', error);
    return data;
  }
};

/**
 * Decrypts AES-256 encrypted string
 * @param {string} encryptedString - The encrypted data
 * @returns {Object|Array|string} - The decrypted parsed JSON or original string if parsing fails
 */
export const decryptData = (encryptedString) => {
  if (!encryptedString || typeof encryptedString !== 'string') return encryptedString;
  
  let workingString = encryptedString;
  if (workingString.startsWith(ENCRYPTION_PREFIX)) {
      workingString = workingString.substring(ENCRYPTION_PREFIX.length);
  } else if (!workingString.startsWith('U2FsdGVkX1')) {
      // Not an encrypted string
      return encryptedString;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(workingString, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedString) {
      console.warn('[Encryption] Decrypted string is empty - decryption likely failed (wrong key?)');
      return encryptedString;
    }

    try {
      return JSON.parse(decryptedString);
    } catch (parseError) {
      // It was just a regular string, not stringified JSON
      return decryptedString;
    }
  } catch (error) {
    console.error('Decryption Failed:', error);
    return encryptedString;
  }
};
